import { memo } from "react";

type Props = {
	basicEndDate?: string;
};

export const CancellationMainDone = memo(({ basicEndDate }: Props) => {
	return (
		<div className="grid gap-4">
			<p className="text-lg/[1rem]">CHILLNNをご利用いただき、ありがとうございました。</p>
			<p className="text-lg/[1rem]">解約処理は完了しております。</p>
			{basicEndDate && <p className="text-lg/[1rem]">{basicEndDate} までは引き続きご利用いただけます。</p>}
		</div>
	);
});
